/**
 * 获取当前环境(从host中判断)
 * @returns dev|test|staging|prod
 */
function getCurEnvFromHost() {
    const curHost = window.location.host;
    let curEnv = 'prod';

    if (curHost.includes('.st.')) {
        curEnv = 'staging'
    } else if (curHost.includes('.test.') || curHost.includes('m.51ping.com')) {
        curEnv = 'test'
    } else if (curHost.includes('dev.') || curHost.includes('127.0.0.1') || curHost.includes('localhost')) {
        curEnv = 'dev'
    }

    return curEnv;
}

const Env = {
    getCurEnvFromHost
}

export default Env